import React, { useContext, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

import { ResourceDetailContext } from 'app/components/Resources/ResourceDetail/ResourceDetailContext';
import ResourceOnboardingSequenceStepTwo from 'app/components/Resources/ResourceDetail/ResourceOnboardingSequence/ResourceOnboardingSequenceStepTwo';
import useResourceOnboardingSequence from 'app/components/Resources/hooks/useResourceOnboardingSequence';
import UrlIcon from 'app/components/shared/icons/url-icon';
import useBehavioral from 'hooks/useBehavioral';

import { ShareBarData } from '..';
import {
  ShareBarShareCTACopiedMessageContainer,
  ShareBarShareCTAText,
  ShareBarShareCTAWrapper,
} from './styled';

export default function ShareBarShareCTA({
  hideOnboarding = false,
  data,
  shareLink,
}: {
  hideOnboarding?: boolean;
  data: ShareBarData;
  shareLink?: string;
}) {
  const { showOnboarding, currentStep } = useResourceOnboardingSequence();
  const [copied, setCopied] = useState<boolean>(false);
  const [mousePosition, setMousePosition] = useState<any>({ x: 0, y: 0 });
  const context = useContext(ResourceDetailContext);
  const shareButtonClickedBehavioral = useBehavioral('SHARE_BUTTON_CLICKED');

  const handleClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    shareButtonClickedBehavioral();
    navigator.clipboard.writeText(shareLink || window.location.href);
    if (context && context.onboardingStep === 2) {
      context.setOnboardingStep(3);
    }
    setMousePosition({ x: e.pageX, y: e.pageY });
    setCopied(true);
  };

  useEffect(() => {
    if (copied) {
      setTimeout(() => {
        setCopied(false);
      }, 2000);
    }
  }, [copied]);

  return (
    <>
      <ShareBarShareCTAWrapper onClick={handleClick}>
        {!hideOnboarding && currentStep && currentStep === 2 && showOnboarding ? (
          <ResourceOnboardingSequenceStepTwo />
        ) : null}
        <UrlIcon width={24} height={24} className="share-bar-share" fill="#000000" />
        <ShareBarShareCTAText>Share Link</ShareBarShareCTAText>
      </ShareBarShareCTAWrapper>
      {copied
        ? ReactDOM.createPortal(
            <ShareBarShareCTACopiedMessageContainer top={mousePosition.y} left={mousePosition.x}>
              Copied!
            </ShareBarShareCTACopiedMessageContainer>,
            document.querySelector('#root')
          )
        : null}
    </>
  );
}
